import { Ord, Ordering as Ordering_, Option } from "fp";

export type Order<A> = Ord.Ord<A>;
export namespace Order {
  export type Ordering = Ordering_;
  export type Compare<A> = (a: A, b: A) => Ordering;

  export const greaterThan = (): Ordering => 1;
  export const equal = (): Ordering => 0;
  export const lessThan = (): Ordering => -1;

  export const number = (): Order<number> => Ord.ordNumber;
  export const string = (): Order<string> => Ord.ordString;

  export const reverse = (ordering: Ordering): Ordering =>
    ordering === 1 ? -1 : ordering === -1 ? 1 : 0;

  export const fromCompare = Ord.fromCompare;

  export const optionally = <A>(compare: Compare<A>) => (
    a?: Option.Nullable<A>,
    b?: Option.Nullable<A>
  ): Ordering =>
    a && b ? compare(a, b) : a ? greaterThan() : b ? lessThan() : equal();
}
